// Calibration Log Book API client
import axios from "axios";
import { setupCsrfInterceptor } from "../auth/csrfUtils";

// Reuse the equipment meters endpoint from the sampling event API (do not duplicate).
export { getSamplingEquipmentMeters } from "./SamplingEventsApi";

const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

setupCsrfInterceptor(api);

const baseUrl = "/calibration_log_book";

// Paginated list with status filter (active|completed) + optional filters object.
// filters keys (from the shared filters state): projectNumber, phase, createdBy,
// createdStartDate (YYYY-MM-DD), createdEndDate (YYYY-MM-DD).
export const getCalibrationLogBooks = async (
  status = "active",
  page = 1,
  perPage = 10,
  filters = {}
) => {
  const params = new URLSearchParams({
    status,
    page: String(page),
    per_page: String(perPage),
  });
  if (filters?.projectNumber) params.set("project_number", filters.projectNumber);
  if (filters?.phase) params.set("phase_id", filters.phase);
  if (filters?.createdBy) params.set("created_by", filters.createdBy);
  if (filters?.createdStartDate)
    params.set("created_start_date", filters.createdStartDate);
  if (filters?.createdEndDate)
    params.set("created_end_date", filters.createdEndDate);

  const response = await api.get(
    `${baseUrl}/calibration_log_books?${params.toString()}`
  );
  return response;
};

// Fetch a single calibration log book (with entries) by id
export const getCalibrationLogBookById = async (bookId) => {
  const response = await api.get(
    `${baseUrl}/calibration_log_book_by_id?book_id=${encodeURIComponent(bookId)}`
  );
  return response;
};

// Create a new (empty) calibration log book; returns { book_id, creation_date }
export const createCalibrationLogBook = async (payload = {}) => {
  const response = await api.post(`${baseUrl}/create_draft`, payload);
  return response;
};

// REST fallback for autosave (environments without WebSocket support)
export const autosaveCalibrationLogBook = async (bookId, patchData) => {
  const response = await api.patch(`${baseUrl}/${bookId}/autosave`, patchData);
  return response;
};

// Complete a calibration log book; returns { task_id } for PDF polling
export const completeCalibrationLogBook = async (bookId) => {
  const response = await api.post(`${baseUrl}/complete`, { book_id: bookId });
  return response;
};

// Soft-delete a calibration log book (server enforces: access level >= 2 or creator)
export const deleteCalibrationLogBook = async (bookId) => {
  const response = await api.post(`${baseUrl}/delete`, { book_id: bookId });
  return response;
};